import React, { Component, Dispatch } from 'react';
import { IExternalLoginProps } from '../../models/pages/login';
import { logOff } from '../../store/actions/login';
import { Common } from '../../core/common';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Log } from 'ng2-logger';
import { IAction, IAppState } from '../../models/action/core';
import { UserType } from '../../models/enums/userType';
import * as ProfilePageAction from '../../store/actions/profile';


let _common: Common;

const _logger = Log.create('external-logout.tsx');
class ExternalLogout extends React.Component<IExternalLoginProps> {
    constructor(props: IExternalLoginProps) {
        super(props);
        _common = new Common();
    }

    componentDidMount() {
        if(this.props.isLogin && this.props.userType === UserType.Admin){
            this.props.dispatch(ProfilePageAction.setProfileAction(null, "setProfileAction", "set"))
            localStorage.clear();
            _common.ClearAuthLocalStorage();
    
            this.props.dispatch(logOff());
            window.location.href = window.appSettings.DEFAULT_URL;
        }
        
    }

    public render() {
        return (
            <div />
        );
    }
};
const dispatchProps = (dispatch: Dispatch<IAction>) => ({
    dispatch
});

const mapStateToProps = (state: IAppState, ownProps: IExternalLoginProps): any => {
    if (!state) {
        return state;
    }

    const returnProps: IExternalLoginProps = Object.assign({}, ownProps, {
        isLogin: state.login.identitiy.isLogin,
        userType: state.login.identitiy.userType
    });
    return returnProps;
};


const CExternalLogout = connect(
    mapStateToProps,
    dispatchProps
)(ExternalLogout);

export default withRouter(CExternalLogout);